import React from 'react';
import './practicalSectionSubmissionForm.module.scss';
import { SubmitButton } from '../../atoms/forms/vertical/base';
import { FieldForm } from '../course_works/FieldForm';
import { SubmitFieldState } from '../../../../commonv3/types/course_works';

type Props = {
  id: string;
  fields: SubmitFieldState[];
  loading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: () => any;
};

export const PracticalSectionSubmissionForm = ({ id, fields, loading, onSubmit }: Props) => {
  return (
    <div id={id}>
      {fields.map((field) => (
        <FieldForm key={field.definition.uid} field={field} />
      ))}
      <div styleName="form-wrapper">
        <SubmitButton loading={loading} onClick={onSubmit} id="submit-button">
          提出する
        </SubmitButton>
      </div>
    </div>
  );
};
